import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export default makeStyles((theme: Theme) =>
  createStyles({
    listTitle: {
      marginBottom: "1rem",
      marginTop: "1rem",
    },
    dialogInputBox: {
      display: "flex",
      "& > *": {
        marginRight: ".5rem",
      },
      alignItems: "center",
    },
    indentedHeader: {
      marginLeft: "1rem",
    },
  })
);
